import { CustomerFeature, customerHasFeature } from 'domain/Customer'

import { hasRoles, Role } from './roles'
import { useAuth } from './useAuth'

interface AccessHookArguments {
  roles: Role[]
  feature?: CustomerFeature
}

export function useAccess(args: AccessHookArguments): boolean {
  const { roles, feature } = args
  const {
    state: { user, customer },
  } = useAuth()
  const hasAccess = hasRoles(user, roles) && (!feature || customerHasFeature(customer, feature))

  return hasAccess
}

export function useAccessToFeature(feature: CustomerFeature): boolean {
  const {
    state: { customer },
  } = useAuth()

  return customerHasFeature(customer, feature)
}
